import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Tag} from "../../../shared/interface/tag";
import {DynamicDictionary} from "../../../shared/interface/dynamic-dictionary";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {TagService} from "../../../shared/services/tag.service";
import {DynamicDictService} from "../../../shared/services/dynamic-dict.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
  selector: 'app-dynamic-dictionary-details-view',
  templateUrl: './dynamic-dictionary-details-view.component.html',
  styleUrls: ['./dynamic-dictionary-details-view.component.scss']
})
export class DynamicDictionaryDetailsViewComponent implements OnInit, OnDestroy {

  @Input() dynamicDictionary: Observable<DynamicDictionary>;
  @Output() modifyClicked = new EventEmitter<any>();

  dynamicDictionaryObject?: DynamicDictionary;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snack: MatSnackBar,
    private auth: AuthService,
    private dynamicDictService: DynamicDictService,
    private dialog: MatDialog,
    private router: Router

  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.dynamicDictionary
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dynamicDictionary: DynamicDictionary) => {
        this.dynamicDictionaryObject = dynamicDictionary;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  load(): void {
    this.dynamicDictService.get(this.dynamicDictionaryObject.id).subscribe((dynamicDictionary: DynamicDictionary) => {
      this.dynamicDictionaryObject = dynamicDictionary;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć wskazany tag?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dynamicDictService.delete(this.dynamicDictionaryObject.id)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto tag', '', {duration: 2000});
            this.router.navigate(['/dynamiczny-slownik']);
          });
      }
    });
  }

}
